import { render, staticRenderFns } from "./GatewayList.vue?vue&type=template&id=391efdda&scoped=true"
import script from "./GatewayList.vue?vue&type=script&lang=js"
export * from "./GatewayList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391efdda",
  null
  
)

export default component.exports